export default __webpack_public_path__ + "static/media/arrow-back.3c013918.svg";